module.exports = __webpack_public_path__ + "img/c00_buildingtechrampartwall_Normal_ua.28295340.webp";